import Vue from 'vue'
import Router from 'vue-router'
import Company from '@/components/company/index'
import Category from '@/components/home/category'
import ProList from '@/components/home/product-list'
import Companylist from '@/components/home/company-list'
import Search from '@/components/home/search'
import ProDetail from '@/components/home/product_details'
import Companypro from '@/components/company/company-product'
import SupplierList from '@/components/home/supplier-list'
import formulaDetails from '@/components/activity/formula_details'
import Index from '@/components/index'
import SearchResult from '@/components/search/result'
import companyDetails from '@/components/company/company-details'
import DemoForm from '@/components/demo/form'

import config from '../common/config';
import utils from '../common/utils';
import platform from '../common/platform';

Vue.use(Router)


const router = new Router({
  scrollBehavior(to, from, savedPosition) {
      return {x: 0, y: to.meta.savedPosition || 0};
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/formuladetails',
      name: 'formula',
      component: formulaDetails
    },
    {
      path: '/company',
      name: 'company',
      component: Company
    },
    {
      path: '/category',
      name: 'category',
      component: Category
    },
    {
      path: '/prolist',
      name: 'list',
      component: ProList
    },
    {
      path: '/companylist',
      name: 'companylist',
      component: Companylist
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/prodetail',
      name: 'prodetail',
      component: ProDetail
    },
    {
      path: '/companypro',
      name: 'companypro',
      component: Companypro
    },
    {
      path: '/companyDetails',
      name: 'companyDetails',
      component: companyDetails
    },
    {
      path: '/supplierlist',
      name: 'supplierlist',
      component: SupplierList
    },
    {
      path: '/search/result',
      name: 'searchresult',
      component: SearchResult,
      meta: {
        keepAlive: true,
        saveSrollTop: true
      }
    },
    {
      path: '/demo/form',
      name: 'demoform',
      component: DemoForm
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (from.meta.saveSrollTop) {
    from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
  }
  if (utils.checkPlatform() === 'pc' && !utils.checkInMiniProgram()) {
    if (platform[to.name]) return platform[to.name](to);
  }
  setTimeout(() => {
    let entityId = '',
        entityType = 'u';
    if (to.name === 'prodetail') {
       entityId = to.query.munufacturer_id;
       entityType = 'youliaoku';
    } else if (to.name === 'formula') {
       entityId = to.query.formula_id;
       entityType = 'u_formula';
    } else if (to.name === 'companyDetails') {
       entityId = to.query.companyId;
       entityType = 'youliaoku';
    }
    if (config.ENV !== 'dev') {
      mhs_access.init({ entityId, entityType, url: location.href });
    }
  }, 100);
  router.app.$nextTick(() => {
    // 在根组件的 mounted 钩子函数执行完毕后再继续导航
    next();
  });
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js